import { render, staticRenderFns } from "./CheckedBox.vue?vue&type=template&id=41298e4b"
import script from "./CheckedBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckedBox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports